import ShareIcon from '@material-ui/icons/Share'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { pipe, propOr } from 'ramda'
import { useEffect, useMemo, useState } from 'react'

import Button from '../../../../components/button'
import useTime from '../../../../hooks/use-time'
import GoogleAnalyticsTrackingStore from '../../../../modules/tracking/stores/google-analytics-tracking-store'
import share from '../../../../utils/share-content'
import { RegisteredEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Registered = () => {
  const now = useTime(5000)
  const {
    push,
    query: { livdemyId, url },
  } = useRouter()
  const { logEvent } = GoogleAnalyticsTrackingStore.useContainer()

  const {
    data,
    registration,
    certification = {
      hasCertification: false,
    },
    upgrade,
  } = CourseHomeStore.useContainer()
  const [upgrading, toggleUpgrading] = useState(false)
  const chapterId = data?.chapters[0]?.id
  const lessonId = data?.chapters[0]?.lessons[0]?.id

  const ongoingClass = useMemo(
    () =>
      pipe(propOr(null, 'nextClass'), (cls) =>
        cls && cls?.startTime < now && cls?.endTime > now ? cls : false,
      )(registration),
    [now, registration],
  )
  const paidEnrollments = registration?.allEnrollments.filter((enrollment) => {
    return enrollment.billStatus === 'PAID'
  })
  const sortedPaidEnrollments = paidEnrollments?.sort((a, b) => {
    return new Date(b.paidAt) - new Date(a.paidAt)
  })
  const lastPaidEnrollment = sortedPaidEnrollments?.[0]

  const lastEnrollment = registration?.allEnrollments?.[0]

  const needUpgrade =
    (lastPaidEnrollment?.billStatus === 'PAID' &&
      !(
        lastPaidEnrollment?.paidAt > Date.now() - 1000 * 60 * 60 * 1 ||
        (lastPaidEnrollment?.sessionCount || 0) < 2
      )) ||
    !lastPaidEnrollment?.registrationType ||
    lastPaidEnrollment?.registrationType === 'STANDARD' ||
    (lastEnrollment?.registrationType === 'UPGRADE' &&
      lastEnrollment?.billStatus !== 'PAID')
  const PendingUpgrade =
    lastEnrollment?.billStatus !== 'PAID' &&
    lastEnrollment?.registrationType === 'UPGRADE'

  return registration?.status !== 'PAID' &&
    registration?.billStatus !== 'PAID' ? null : (
    <RegisteredEl>
      {ongoingClass ? null : (
        <Button
          onClick={() => {
            logEvent({
              action: 'shared content',
              category: 'usage',
              label: `/${livdemyId}/course/${url}`,
            })
            return share(
              {
                text: data?.name,
                url: `/${livdemyId}/course/${url}`,
              },
              `/${livdemyId}/course/${url}`,
            )
          }}
          startIcon={<ShareIcon />}
          theme='secondary'
        >
          Share
        </Button>
      )}

      {data.type === 'recorded' ? (
        // eslint-disable-next-line @next/next/link-passhref
        <Link
          href={`/${livdemyId}/course/${url}/chapter/${chapterId}/lesson/${lessonId}`}
        >
          <Button theme='primary'>Start Watching</Button>
        </Link>
      ) : (
        // eslint-disable-next-line @next/next/link-passhref
        <Link href={`/${livdemyId}/course/${url}/dashboard`}>
          <Button theme={ongoingClass ? 'secondary' : 'primary'}>
            Dashboard
          </Button>
        </Link>
      )}
      {!ongoingClass ? null : (
        // eslint-disable-next-line @next/next/link-passhref
        <Link
          href={`/${livdemyId}/course/${url}/batch/${
            ongoingClass?.batchId || ongoingClass?.info?.batchId
          }/classroom`}
        >
          <Button theme='primary'>Go to class</Button>
        </Link>
      )}
      {needUpgrade && certification?.hasCertification ? (
        <Button
          onClick={async () => {
            if (PendingUpgrade) {
              push(`/${livdemyId}/course/${url}/payment`)
            } else {
              toggleUpgrading(true)
              await upgrade()
              toggleUpgrading(false)
            }
          }}
          theme='primary'
          disabled={upgrading}
        >
          {PendingUpgrade ? 'Complete Upgrade' : 'Upgrade'}
        </Button>
      ) : (
        <></>
      )}
    </RegisteredEl>
  )
}

export default Registered
